var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.088,
    height: 22.088,
    viewBox: "0 0 22.088 22.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "summarize_FILL0_wght400_GRAD0_opsz48",
    d: "M11.8,12.718a.944.944,0,1,0-.644-.276A.883.883,0,0,0,11.8,12.718Zm0,5.246a.944.944,0,1,0-.644-.276A.883.883,0,0,0,11.8,17.964Zm0,5.246a.944.944,0,1,0-.644-.276A.883.883,0,0,0,11.8,23.21ZM7.841,28.088A1.887,1.887,0,0,1,6,26.247V7.841A1.887,1.887,0,0,1,7.841,6H22.014l6.074,6.074V26.247a1.887,1.887,0,0,1-1.841,1.841Zm0-1.841H26.247V13.087H21V7.841H7.841V26.247Zm0-18.407V26.247h0V7.841Z",
    transform: "translate(-6 -6)",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.230c85f1b3b647f06f7fd011cd0f486a.svg";
export { ForwardRef as ReactComponent };